import { CommonModule } from "@angular/common";
import { Component, HostListener, Input } from "@angular/core";
import { TreeNode } from "../../core/models/treeNode";

export interface VersionBadgeData {
  label: string;
  tree: TreeNode[];
}

/**
 * Reusable cell widget that shows the current active version label as a
 * clickable badge. Clicking toggles a popover with the full version history.
 *
 * NOTE: This component intentionally does NOT import app-tree-view because
 * app-tree-view spreads SharedComponents (which contains ZorroTableComponent,
 * which imports this component), creating a circular dependency. The version
 * history is therefore rendered with a plain two-level list template.
 *
 * Used as a column type `'version-badge'` inside app-zorro-table.
 */
@Component({
  selector: "app-version-badge-dropdown",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./version-badge-dropdown.component.html",
  styleUrl: "./version-badge-dropdown.component.scss",
})
export class VersionBadgeDropdownComponent {
  @Input() data: VersionBadgeData | null = null;

  isOpen = false;
  /** Tracks which nodes are expanded inside the version popup. */
  expandedIds = new Set<string>();

  toggle(event: Event): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  toggleNode(event: Event, node: TreeNode): void {
    event.stopPropagation();
    if (this.expandedIds.has(node.id)) {
      this.expandedIds.delete(node.id);
    } else {
      this.expandedIds.add(node.id);
    }
  }

  isExpanded(node: TreeNode): boolean {
    return this.expandedIds.has(node.id);
  }

  @HostListener("document:click")
  onDocumentClick(): void {
    this.isOpen = false;
  }
}
